import Layout from "../../../views/Layout/Layout";
import App from "../../App";

const Hotmenu = {

    init() {

        this.el = $('[component="Hotmenu"]');

        if (!this.el.length) {
            return;
        }

        this.button = {
            ajax: this.el.find('[element="ajax"]')
        }

        this.start();
        this.bind();
    },

    start() {

    },

    bind() {
        this.button.ajax.on("click", (element) => {

            if ($(element.currentTarget).is(".disabled")) {
                return;
            }

            if (!$(element.currentTarget).find(".littleLoading").length) {
                $(element.currentTarget).append($('[element="littleLoading"]').contents().clone());
            }

            $(element.currentTarget).addClass("disabled");

            clearTimeout(App.ajaxSendProtection);

            App.ajaxSendProtection = setTimeout(() => {

                let button = $(element.currentTarget).data();
                let cronLink = App.getCronJobLink(button.job);

                if (!cronLink) {
                    console.error("Missing cron link");
                    return false;
                }

                App.showLoading();
                App.ajax(
                    button.library,
                    button.event,
                    {
                        link: CRON_ADRESS_SECURED,
                        request: cronLink
                    },
                    (response) => {

                        setTimeout(() => {
                            $(element.currentTarget).removeClass("disabled");
                        }, 2000);

                        if (!response.storage_link) {
                            return;
                        }

                        Hotmenu.el.find(".disabled").removeClass("disabled");
                        Hotmenu.el.attr("class", "reportFound");
                        Hotmenu.el.parents('[component="Alert"]').addClass("reportFound");

                        $('.storageLink').attr("href", response.storage_link);
                    }
                )

                Layout.hideModal(this.dialog);
            }, 500);

            return false;
        });

        this.el.find("a").on("click", (element) => {
            //console.log($(element.currentTarget).attr("href"));
            //window.location = $(element.currentTarget).attr("href")
        });
    },
}
export default Hotmenu;